var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-custom",staticStyle:{"height":"500px","overflow-x":"hidden"}})}
var staticRenderFns = []

export { render, staticRenderFns }